Ext.define('SA.view.pvt.AutoRefreshingLocationDropdown', {
    alias: 'widget.pvt-auto-refreshing-location-dropdown',
    extend: 'SA.view.pvt.LocationDropdown',

    beforeRender() {
        this.callParent();

        if (this.hasModel()) {
            this.onModelSet();
        }
    },

    buildItems() {
        if (!this.hasModel()) {
            return [];
        }

        return SA.data.LocationsCache.get(this.projectView.getSupportedProjectLocations());
    },

    hasModel() {
        return !!this.projectView;
    },

    onModelSet() {
        this.refresh();

        this.mon(this.projectView, 'change:location', this.refresh, this);
        this.mon(SA.data.LocationAliases, 'change', this.refreshText, this);
        this.mon(this.projectModel, 'change:location', this.refreshItems, this);
    },

    refresh() {
        var location = SA.data.LocationsCache.get(this.projectView.getLocation());

        this.setValue(location || null);
    },

    selectHandler(location) {
        var projectView = this.projectView;

        if (location) {
            location = SA.data.LocationsCache.toLocationSeries(location);
        }

        if (projectView.addLocation(location)) {
            projectView.save();

            if (location) {
                SA.data.RecentLocations.add(location);
            }
        }
    },

    setProjectView(projectView) {
        this.projectView = projectView;
        this.projectModel = projectView.getProject();

        this.refreshItems();

        this.onModelSet();
    }
});